window.shareItOnFacebook = function() {
    const url = `https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(location.href)}`;
    window.open(url, "newwindow", "width=750,height=600,scrollbars=yes,resizable=yes");
    void(0);
};

window.shareItOnTwitter = function() {
    window.open(`https://twitter.com/share?url=${escape(window.location.href)}`,
        "newwindow",
        "menubar=no,toolbar=no,resizable=yes,scrollbars=yes,height=300,width=600");
    void(0);
};

(function($) {
    $('.report-ad-form').submit(function (e) {                
        const reportData = $(this).serialize();

        const $form = $('.report-ad-form');
        const reportUrl = $form.attr("action");

        // Progress
        $form.find(".form-control, .btn").prop("disabled", true);
        $form.find(".btn").html("Submitting...");

        function success() {
            $form.find("input, textarea").val("");
            $form.find('.notification .text-success').show();
            $form.find('.notification .text-danger').hide();

            $form.find(".form-control, .btn").prop("disabled", false);
            $form.find(".btn").html("Submit");
        }

        function failure() {
            $form.find('.notification .text-success').hide();
            $form.find('.notification .text-danger').show();

            $form.find(".form-control, .btn").prop("disabled", false);
            $form.find(".btn").html("Submit");
        }
        
        $.ajax({
            url: reportUrl,
            contentType: 'application/x-www-form-urlencoded',            
            data: reportData,
            type: 'POST',
            success: function (data) {
                if (data.reported) {
                    success();
                } else {
                    failure();
                }
            },
            error: function () {
                failure();
            }
        });

        e.preventDefault();
    });
})(jQuery);